import { TextInputWithLabel } from '@/src/common/components/elements/Forms/TextInputWithLabel'
import { cardTextMax } from '@/src/modules/build-a-card/constants'
import { BaseSyntheticEvent } from 'react'
import { FormErrorDisplay } from '@/src/modules/build-a-card/FormErrorDisplay'
import { ValidationError } from 'yup'
import { cleanCardFieldInput } from '@/src/common/utilities/handleEmoji'
import { HeaderParagraphText } from '@/src/modules/build-a-card/StyledComponents'
import { FieldWrapperWithGap } from '@/src/common/components/elements/Forms/StyledComponents'
import { SimpleFieldWrapper } from '@/src/modules/build-a-card/StepElement'

const EmbossFields = ({
    nameOnCard,
    setNameOnCard,
    messageOnCard,
    setMessageOnCard,
    formErrors,
    headerText = 'Customize text on card:',
    labelText = {
        nameField: 'Name',
        messageField: 'Message',
    },
}: {
    nameOnCard: string
    setNameOnCard: Function
    messageOnCard: string
    setMessageOnCard: Function
    formErrors: ValidationError[]
    headerText?: string
    labelText?: { nameField: string; messageField: string }
}) => {
    const isEmboss = true
    return (
        <SimpleFieldWrapper>
            <HeaderParagraphText>{headerText}</HeaderParagraphText>
            <FieldWrapperWithGap>
                <TextInputWithLabel
                    isRequired={true}
                    label={labelText.nameField}
                    placeholder={'Name'}
                    value={nameOnCard}
                    maxLength={cardTextMax}
                    onChange={(e: BaseSyntheticEvent) => {
                        const trimmedValue = cleanCardFieldInput(
                            e.currentTarget.value,
                            isEmboss
                        )

                        setNameOnCard(trimmedValue)
                    }}
                />
                <FormErrorDisplay
                    formErrors={formErrors}
                    path={'nameOnCard'}
                    variant={'error-message'}
                />
                <TextInputWithLabel
                    isRequired={true}
                    label={labelText.messageField}
                    placeholder={'Add a message...'}
                    maxLength={cardTextMax}
                    value={messageOnCard}
                    onChange={(e: BaseSyntheticEvent) => {
                        const trimmedValue = cleanCardFieldInput(
                            e.currentTarget.value,
                            isEmboss
                        )

                        setMessageOnCard(trimmedValue)
                    }}
                />
                <FormErrorDisplay
                    formErrors={formErrors}
                    path={'messageOnCard'}
                    variant={'error-message'}
                />
            </FieldWrapperWithGap>
        </SimpleFieldWrapper>
    )
}

export default EmbossFields
